// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hqiessmspmnaulhkbizj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhxaWVzc21zcG1uYXVsaGtiaXpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3ODM0NDksImV4cCI6MjA2ODM1OTQ0OX0.8NnkCG4b5fo9bxPxEgplMP_qFJ48_91HBQGoBfToJjQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});